/**
 * default exports for other modules to use
 */

import axios from "axios";
import Emitter from "./emitter";

export const url =
	window.location.hostname === "localhost"
		? `http://localhost:${import.meta.env.VITE_PORT_SERVER}/api`
		: `${window.location.origin}/api`;
export const superAdminRole: any = import.meta.env.VITE_SUPER_ADMIN_TAG;
export let accessToken: any = localStorage.getItem(`accessToken`);
export const idToken: any = localStorage.getItem(`idToken`);
export let pbiToken: any = localStorage.getItem(`pbiToken`);
export let AuthHeader: any = {
	headers: {
		Authorization: accessToken,
		api_key: import.meta.env.VITE_API_KEY,
	},
	withCredentials: true,
};

export const httpAgent = axios.create({
	baseURL: `${url}`,
	...AuthHeader,
});

Emitter.on("refreshed", () => {
	accessToken = localStorage.getItem(`accessToken`);
	pbiToken = localStorage.getItem(`pbiToken`);
	AuthHeader = {
		headers: {
			Authorization: accessToken,
			api_key: import.meta.env.VITE_API_KEY,
		},
		withCredentials: true,
	};
	httpAgent.defaults.headers.Authorization = accessToken;
});
